import { createContext } from "react";

export const RegistrationDataContext = createContext([]);